import React from 'react'

const MoneyBackAccount = () => {
    return (
        <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 flex flex-col gap-8'>
            <div>
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
                    Sai Samriddhi Money Back Plan: Secure Your Future with Flexible Investment Options
                </h2>
                <p className="text-md text-gray-600 mx-auto leading-relaxed">
                    Sai Samriddhi Money Back Plan: Secure Your Future with Flexible Investment Options
                    Are you looking for a reliable investment plan that combines the benefits of regular income with long-term growth? The Sai Samriddhi Money Back Plan offers two tailored options to suit your financial needs: the Deposit Per Month plan and the Deposit Amount Per Day plan. Both options are designed to help you achieve your financial goals while ensuring periodic returns and a secure future.
                </p>
            </div>

            <div>
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
                    Plan 1: Deposit Per Month

                </h2>
                <p className="text-md text-gray-600 mx-auto leading-relaxed">
                    With the Deposit Per Month plan, you can invest a fixed amount every month for a duration of 84 months. This plan is ideal for individuals who prefer to make consistent monthly deposits. Benefits include:

                    Deposit Per Month plan, you can invest a fixed amount every month for a duration of 84 months. This plan is ideal for individuals who prefer to make consistent monthly deposits. Benefits include:
                    Regular Monthly Investments: Contribute a set amount every month, making it easier to manage your finances and budget.
                    Periodic Payouts: Receive money back at regular intervals throughout the investment term, providing financial liquidity and flexibility.
                    Attractive Returns: Enjoy competitive interest rates and bonuses on your total investment, enhancing your savings growth.
                    Structured Savings: Ideal for systematic investors who want to build wealth over time with a predictable savings plan.
                </p>
            </div>
            <div className='flex justify-center items-center'>
                <img src='https://www.saisamriddhi.in/wp-content/uploads/2024/09/Screenshot-2024-09-12-at-1.05.45%E2%80%AFAM-min.png' />
            </div>
            <div>
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
                    Plan 2: Deposit Amount Per Day
                </h2>
                <p className="text-md text-gray-600 mx-auto leading-relaxed">
                    The Deposit Amount Per Day plan allows you to invest a daily amount for 84 months. This plan is perfect for those who prefer to save small amounts daily. Key features include:

                    Daily Savings: Contribute a nominal amount each day, which can be easier to manage than larger monthly or annual deposits.
                    Frequent Returns: Benefit from money back at regular intervals during the plan term, ensuring continuous financial support.
                    Enhanced Compounding: Daily deposits can lead to more frequent compounding of interest, potentially increasing your overall returns.
                    Flexible Investment: Suitable for individuals who wish to integrate savings into their daily routine without significant financial strain.
                </p>
            </div>

            <div className='flex justify-center items-center'>
                <img src='https://www.saisamriddhi.in/wp-content/uploads/2024/09/Screenshot-2024-09-12-at-12.52.51%E2%80%AFAM.png' />
            </div>

            <div>
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
                    Why Choose Sai Samriddhi Money Back Plan?
                </h2>
                <p className="text-md text-gray-600 mx-auto leading-relaxed">
                    Customizable Investment: Choose the plan that best fits your financial habits and goals, whether it’s monthly or daily deposits.
                    Financial Security: Ensure regular returns and a lump sum payout at maturity, providing financial stability and peace of mind.
                    Growth Potential: Take advantage of attractive interest rates and bonuses to grow your savings over time.
                    Convenient Management: Both plans are designed to offer ease of management and flexibility, adapting to your lifestyle and financial situation.
                </p>
            </div>




        </div>
    )
}

export default MoneyBackAccount
